import { Component, HostBinding, Input } from '@angular/core';
import { AvatarComponent } from '@brand-lolly/app/shared-components/avatar.component';
import { TypographyComponent } from 'components';

@Component({
	standalone: true,
	selector: 'app-profile-menu-header',
	template: `
		<avatar
			[size]="largeSize ? '3rem' : '2.25rem'"
			[url]="image"
			[loading]="imageLoading"
		></avatar>
		<div class="info">
			<typography
				class="profile-name"
				[variant]="largeSize ? 'h/3' : 'p/sm_semibold'"
			>
				{{ fullName }}
			</typography>
			<typography
				class="profile-email"
				[variant]="largeSize ? 'p/sm_medium' : 'p/xs_regular'"
				style="opacity: 0.5;"
			>
				{{ email }}
			</typography>
		</div>
	`,
	imports: [AvatarComponent, TypographyComponent],
	styles: [
		`
			:host {
				display: flex;
				padding: 1rem;
				border-bottom: 1px solid #dcdcdc;
				column-gap: 0.5rem;
				align-items: center;

				&.large-size {
					padding: 0.75rem 1rem;
				}

				.info {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
				}
			}
		`
	]
})
export class ProfileMenuHeaderComponent {
	@Input() image: string;
	@Input() imageLoading: boolean;
	@Input() fullName: string;
	@Input() email: string;

	@Input() @HostBinding('class.large-size') largeSize = false;
}
